export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13519.a0a1d12b.jpg";